import React, { useEffect, useState } from "react";
import { Link } from "react-feather";

const KeywordUrl = ({ domain, keyword }) => {
  const [rankName, setRankName] = useState("");
  const [rankPath, setRankPath] = useState("");

  useEffect(() => {
    try {
      setRankName(keyword.rankUrl.split(domain.name)[1]);
      setRankPath(keyword.rankUrl);
    } catch (err) {
      setRankName("/");
      setRankPath(`http://${domain.name}/`);
    }
  }, [domain]);

  return (
    <a className="truncate-250" href={rankPath} target="_blank">
      <Link style={{ width: "12px" }} /> ...
      {rankName && rankName.substr(rankName.length - 5)}
    </a>
  );
};

export default KeywordUrl;
